import React, {useEffect, useState} from "react";
import {message, Result, Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {useApi} from "../ApiProvider";
import {Main} from "../Main";

export function FetchFHIR() {
    const [loadingFhir, setLoadingFhir] = useState(false);
    const [fhirFetched, setFhirFetched] = useState(false);
    const [countdown, setCountdown] = useState(5);
    const api = useApi();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const state = params.get("state");
        const code = params.get("code");
        console.log('state')
        console.log(state)
        console.log('code')
        console.log(code)

        if (!code || (state !== "charm" && state !== "epic" && state !== "athena" && state !== "cerner")) return;

        const fhirBaseUrl = sessionStorage.getItem("fhir_base_url");
        const redirectUrl = sessionStorage.getItem("redirect_url");
        const executionId = sessionStorage.getItem("execution_id") ?? undefined;
        const tabName = sessionStorage.getItem("tab_name") ?? undefined;
        const clientId = sessionStorage.getItem("client_id");

        if (!fhirBaseUrl || !clientId || !redirectUrl) {
            message.error("Missing required session data; cannot fetch FHIR.");
            return;
        }

        const codeVerifier = state === "epic" || "athena" || "cerner" ? sessionStorage.getItem("pkce_verifier") ?? undefined : undefined;

        (async () => {
            setLoadingFhir(true);
            try {
                await api.extractFhirData({
                    code,
                    fhirUrl: fhirBaseUrl,
                    codeVerifier,
                    redirectUrl,
                    clientId,
                    executionId,
                    tabName,
                    state
                });
                setFhirFetched(true);
            } catch (err) {
                console.error(err);
                message.error("Failed to fetch FHIR data. Please try again.");
            } finally {
                setLoadingFhir(false);
            }
        })();
    }, [api]);

    useEffect(() => {
        if (!fhirFetched) return;
        const timer = setInterval(() => {
            setCountdown((c) => c - 1);
        }, 1000);
        return () => clearInterval(timer);
    }, [fhirFetched]);

    useEffect(() => {
        if (countdown === 0) {
            window.close();
        }
    }, [countdown]);

    /* ------------------------------------------------------------------ */
    /*  Overlay styles                                                    */
    /* ------------------------------------------------------------------ */
    const overlayStyle: React.CSSProperties = {
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 10000,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        backdropFilter: "blur(2px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    };

    return (
        <>
            {loadingFhir && (
                <div style={overlayStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: 16, transform: "translateY(-50px)" }}>
                        <Spin indicator={<LoadingOutlined spin />} size="large" />
                        <div style={{ fontSize: 20, fontWeight: 500, color: "#333" }}>Fetching FHIR data…</div>
                    </div>
                </div>
            )}

            {fhirFetched && !loadingFhir && (
                <div style={overlayStyle}>
                    <Result
                        status="success"
                        title="Great! All FHIR data is fetched."
                        subTitle={`This tab will be closed automatically in ${countdown}…`}
                    />
                </div>
            )}
            <Main />
        </>
    );
}
